export default [
  {
    path: "finances",
    name: "finances",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:finance" */ "@/views/Webmaster/FinanceView.vue")
  }
];
